import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { commonFeatureKey, CommonState } from './common.state';

export const selectSystemModulesState: MemoizedSelector<object, CommonState> = createFeatureSelector<CommonState>(commonFeatureKey);

export const selectLoading = createSelector(selectSystemModulesState, (state: CommonState) => state.loading);
export const selectSystemModules = createSelector(selectSystemModulesState, (state: CommonState) => state.systemModules || []);
export const selectSystemModulesError = createSelector(selectSystemModulesState, (state: CommonState) => state.error);
export const selectSystemModulesSuccess = createSelector(selectSystemModulesState, (state: CommonState) => state.loadSystemModulesSuccess);
